export default "__VITE_ASSET__CpJn56pI__"